// @flow weak

import $ from 'jquery';
import _ from 'lodash';
import { routeTo } from 'redux-router-kit';

import _str from 'app/common/underscore-string';
import delay from 'app/common/delay';
import z from 'app/common/z';
import { ensureArray } from 'app/common/CommonUtils';

export const maybeUnsafeRouteOptions = (options = {}) => {
  return {
    ...options,
    isMaybeUnsafe: true,
  };
};

export const loadJs = urls => {
  urls = _.compact(ensureArray(urls));
  return new Promise(resolve => {
    $.getScripts(urls, resolve);
  });
};

const doesUrlMatch = (urls, urlToMatch) =>
  _.find(urls, url => _str.endsWith(url, urlToMatch));

export const loadCss = urls => {
  urls = _.compact(ensureArray(urls));
  const styleSheets = _.toArray(document.styleSheets);
  const loadedUrls = _.compact(styleSheets.map(sheet => sheet.href));
  const neededUrls = urls.filter(url => !doesUrlMatch(loadedUrls, url));
  if (neededUrls.length === 0) {
    return Promise.resolve();
  }
  return Promise.all(
    neededUrls.map(url => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = url;
      const linkPromise = new Promise((resolve, reject) => {
        link.onload = resolve;
        link.onerror = reject;
        if (document.head) {
          document.head.appendChild(link);
        }
      });
      // After a second, give up waiting on CSS.
      return Promise.race([linkPromise, delay(1000)]);
    })
  );
};

export const dangerouslyDoNav = (arg1, arg2) => {
  if (_.isString(arg1)) {
    if (arg1[0] !== '/') {
      arg1 = `/${arg1}`;
    }
    return z.app.dangerousGlobalStore.dispatch(routeTo(arg1, arg2));
  }
  if (_.isObject(arg1) || arg1 === null) {
    if (arg2[0] !== '/') {
      arg2 = `/${arg2}`;
    }
    return z.app.dangerousGlobalStore.dispatch(
      routeTo(arg2, {
        event: arg1,
      })
    );
  }
  console.warn(`doNav args are messed up:`, arg1, arg2);
  return Promise.resolve();
};

// Evil function to get backbone-compatible global fragment.
// This should only be used until we eradicate the old backbone code.
// DO NOT USE THIS!!!
export const dangerousFragmentNeverUseThis = () => {
  const { router } = z.app.dangerousGlobalStore.getState();
  if (!router.current) {
    return null;
  }
  if (router.current.location.pathname[0] === '/') {
    return router.current.location.pathname.substring(1);
  }
  return router.current.location.pathname;
};

// Evil function to get global location.pathname.
// This should only be used until we eradicate the old backbone code.
// DO NOT USE THIS!!!
export const dangerousLocationNeverUseThis = () => {
  const { router } = z.app.dangerousGlobalStore.getState();
  return _.get(router, ['current', 'location']) || window.location || {};
};

export const dangerouslyListenToRouteChange = onRouteChange => {
  const store = z.app.dangerousGlobalStore;
  const { router: initialRouter } = store.getState();
  let prev = initialRouter && initialRouter.current;
  return store.subscribe(() => {
    const { router } = store.getState();
    const current = router && router.current;
    if (prev !== current) {
      onRouteChange();
      prev = current;
    }
  });
};

export const assignParams = newParams => ({
  assign: ({ params }) => ({ params: { ...params, ...newParams } }),
});
